module.exports = __webpack_public_path__ + "assets/AirbnbCereal-Book.8f310788cbaa1e24bc239461c815f846.woff";